const SDK_VERSION = '7.70.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map



// WEBPACK FOOTER //
// ./node_modules/@sentry/core/esm/version.js